<template>
    <button :type="type" :id="id" :class="classNames" :disabled="disabled" @click="$event.target.blur()">
        <svg-vue v-if="icon && iconBefore" :icon="icon" class="icon"/>
        <span><slot /></span>
        <svg-vue v-if="icon && !iconBefore" :icon="icon" class="icon"/>
    </button>
</template>

<script>
export default {
    name: 'FormButton',
    props: [
        'id',
        'color',
        'icon',
        'iconBefore',
        'type',
        'disabled',
        'dense',
        'rounded',
    ],
    emits: ['submit'],
    computed: {
        classNames() {
            let classNames = ['btn'];
            if (this.color) classNames.push(`btn--${this.color}`);
            if (this.dense) classNames.push('btn--dense');
            if (this.rounded) classNames.push('btn--rounded');
            if (this.icon && this.$slots.default) classNames.push('btn--icon');
            if (this.icon && !this.$slots.default) classNames.push('btn--icon-inline');

            return classNames;
        }
    },
};
</script>
